/**
 * The base Freshdesk URL where the API is accessible.
 * @type {string}
 */
export const FRESHDESK_BASE_URL = `${process.env.REACT_APP_DELIVO_API_BASE_URL}/v1/accounts/freshdesk`;
export const FRESHDESK_TICKETS_URL = `${FRESHDESK_BASE_URL}/`;
export const FRESHDESK_SSO_URL = `${process.env.REACT_APP_DELIVO_API_BASE_URL}/v1/accounts/sign/`;
export const FRESHDESK_SUPPORT_TICKET_PAGE = (ticketId) =>
  `${process.env.REACT_APP_FRESHDESK_BASE_URL}/support/tickets/${ticketId}`;
